<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->

                <!-- Project Title -->
                <h2>Site de tennis en HTML CSS</h2>
                <!-- Project date + duration -->
                <h4><b>Fin :</b> Mars 2020</h4>
                <h4><b>Durée :</b> 2 semaines</h4>
                <li><a href="https://tennis-hugo.netlify.app">Mon site </a></li>

                <!-- Project image -->
                <img src="assets/ten.PNG" width="1256">
                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/html.png" />
                                <img class="dot" src="assets/skills/css.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p>Html , Css </p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Contexte :</b></h4>
                            <p>

                            </p>

                            <h4><b>Présentation du projet :</b></h4>
                            <p>

                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">

                            <h4><b>Bilan :</b></h4>
                            <p>

                            </p>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
            <!-- Images of the project -->
            <!-- TODO: add images from project -->

        </div>
    </div>
</div>

<app-projects></app-projects>